import React from 'react';
import PropTypes from 'prop-types';
import { trans, getPagePath } from '@spotahome/soyuz/client';
import { Link } from '@spotahome/ui-library';

import FAQAccordion from './FAQAccordion';

import './FAQSection.scss';

const FAQSection = ({ questions }) => (
  <section className="faq-section">
    <h2 className="faq-section__title">
      {trans('home.tenant.FAQ-section.title')}
    </h2>
    <div className="faq-section__accordion-wrapper">
      <FAQAccordion data={questions} theme={FAQAccordion.themes.tenant} />
    </div>
    <div className="faq-section__bottom">
      {`${trans('home.tenant.FAQ-section.footer.title')} `}
      <Link
        href={getPagePath('help-center')}
        target="_blank"
        rel="noopener noreferrer"
      >
        {trans('home.tenant.FAQ-section.footer.link')}
      </Link>
    </div>
  </section>
);

FAQSection.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      top: PropTypes.node.isRequired,
      content: PropTypes.node.isRequired,
      isOpened: PropTypes.bool
    })
  ).isRequired
};

export default FAQSection;
